import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import classNames from 'classnames';
import Button from '@prism/button';
import PrismTooltip from '../tooltip/prismTooltip';

class PrismButton extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        className: PropTypes.string,
        buttonClassName: PropTypes.string,
        tooltip: PropTypes.string,
        tooltipPlacement: PropTypes.string,
        aux: PropTypes.bool,
        active: PropTypes.bool,
        outline: PropTypes.bool,
        textonly: PropTypes.bool,
        icononly: PropTypes.bool,
        size: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };

    static defaultProps = {
        aux: false,
        active: false,
        outline: false,
        textonly: false,
        icononly: false,
        disabled: false
    };

    state = {
        tooltipOpen: false
    };

    constructor(props) {
        super(props);

        this._wrapperRef = React.createRef();
        this._wrapperId = `prism-button-container-${uuid()}`;
    }

    componentDidMount() {
        this._wrapperRef.current.onmouseenter = this.toggleTooltip;
        this._wrapperRef.current.onmouseleave = this.toggleTooltip;
    }

    toggleTooltip = () => {
        const { tooltipOpen } = this.state;

        this.setState({
            tooltipOpen: !tooltipOpen
        });
    }

    render() {
        const {
            className,
            buttonClassName,
            tooltip,
            tooltipPlacement,
            children,
            ...elementProps
        } = this.props;
        const {
            tooltipOpen
        } = this.state;

        const containerClassName = classNames(
            'prism-button-container',
            'prism-sandbox',
            className
        );

        const elementClassName = classNames(
            'prism-button',
            buttonClassName
        );

        return (
            <div
                ref={this._wrapperRef}
                id={this._wrapperId}
                className={containerClassName}
            >
                <Button
                    {...elementProps}
                    className={elementClassName}
                >
                    {children}
                </Button>
                {tooltip && (
                    <PrismTooltip
                        target={this._wrapperId}
                        size="lg"
                        placement={tooltipPlacement}
                        isOpen={tooltipOpen}
                        targetIsFunctional
                    >
                        {tooltip}
                    </PrismTooltip>
                )}
            </div>
        );
    }
}

export default PrismButton;
